import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../Translations';
import Books from '../../../../../../Cutesies/Books';
import CloseIcon from '../../../../../../Cutesies/CloseIcon';
import Store from '../Store';

interface Props {
  store: Store;
}

const SelectingHeader: React.FC<Props> = ({ store }) => (
  <div className="fixed w-4/5 bg-white">
    <div
      className={clsx(
        'border-0 bg-transparent text-2xl font-medium outline-none',
        'float-right cursor-pointer py-8 px-11 opacity-80 hover:opacity-100',
      )}
      onClick={store.closeModal}
      data-test-close-button={true}
      role="button"
    >
      <CloseIcon />
    </div>
    <div className="pt-8">
      <h3 className="flex flex-row items-center gap-2 px-11 py-4 text-xl font-semibold">
        <Books />
        <T kind="Program Catalog" />
      </h3>
    </div>
  </div>
);

export default observer(SelectingHeader);
